export default __webpack_public_path__ + "locales/pl/Ldap.json?hash=939ac3d5fcac00974e89a355dcff0577";